export const ONBOARDING_PLANS = [
  {
    key: "basic",
    publicPlanId: "basic",
    packageId: "digital_agent",
    title: "Digital Agent (Basic)",
    price: "S$129 / month",
    body: "Best for new or part-time agents who want a polished portal and a clean operating base.",
  },
  {
    key: "pro",
    publicPlanId: "pro",
    packageId: "alpha_investor",
    title: "Alpha Investor (Pro)",
    price: "S$249 / month",
    body: "Best for individual top producers who want full Alpha Intelligence, Signature Advisor, and live command tools.",
    recommended: true,
  },
  {
    key: "elite",
    publicPlanId: "elite",
    packageId: "elite_team",
    title: "Elite Team (Enterprise)",
    price: "S$899 / month",
    body: "Best for team leaders and boutique bosses who need team-wide branding, triage, and coordinated execution.",
  },
];

export const PUBLIC_PLAN_TO_PACKAGE = {
  basic: "digital_agent",
  pro: "alpha_investor",
  elite: "elite_team",
  digital_agent: "digital_agent",
  alpha_investor: "alpha_investor",
  elite_team: "elite_team",
};

export const PACKAGE_TO_PUBLIC_PLAN = {
  digital_agent: "basic",
  alpha_investor: "pro",
  elite_team: "elite",
  "Digital Agent": "basic",
  "Alpha Investor": "pro",
  "Elite Team": "elite",
};

export const resolvePackageIdFromPlan = (value) => PUBLIC_PLAN_TO_PACKAGE[value] || "alpha_investor";
export const resolvePublicPlanFromPackage = (value) => PACKAGE_TO_PUBLIC_PLAN[value] || "pro";
export const resolveSelectedPlan = (value) => {
  const packageId = resolvePackageIdFromPlan(value);
  return ONBOARDING_PLANS.find((plan) => plan.packageId === packageId) || ONBOARDING_PLANS[1];
};